import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  scrollToPurchase?: boolean;
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false,
  scrollToPurchase = false
}: CTAButtonProps) {
  const handleClick = () => {
    if (scrollToPurchase) {
      const purchaseSection = document.getElementById('purchase-section');
      if (purchaseSection) {
        purchaseSection.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    } else {
      window.location.href = 'https://pay.hotmart.com/S103405068E';
    }
  };
  return <motion.button whileHover={{
    scale: 1.02,
    boxShadow: '0 10px 25px -5px rgba(157, 75, 107, 0.4)'
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        relative overflow-hidden group
        bg-[#9d4b6b] text-white font-medium text-lg md:text-xl
        py-4 px-8 rounded-full shadow-lg shadow-[#9d4b6b]/20
        transition-colors duration-300
        flex items-center justify-center gap-2
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} data-id="element-5">
      <span className="relative z-10" data-id="element-6">{children}</span>
      <ArrowRight className="w-5 h-5 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-7" />
      <div className="absolute inset-0 bg-white/10 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-8" />
    </motion.button>;
}